import React from "react";
import Layout from "../components/layout";
import FlipCard from "../components/FlipCard";
import wave from "../images/wave.svg";
import Adaptino from "../components/img-components/Adaptino";
import PogChamp from "../components/img-components/PogChamp";
import Guess from "../components/img-components/Guess";
import OnlineResume from "../components/img-components/OnlineResume";
import Tauren from "../components/img-components/Tauren";
import SEO from "../components/seo";

const IndexPage = () => (
  <Layout>
    <SEO title="Damian Wilk - Portfolio" />
    {/* Wave */}
    <img id="wave1" src={wave} alt="" />
    <section id="projects" className="mb-2">
      <div className="container text-center">
        <h2 className="mb-2" style={{ paddingTop: "10px" }}>
          Projects
        </h2>
        <div className="flex-group">
          {/* Project 1 */}
          <FlipCard
            frontImage={<Adaptino />}
            title="Adaptino"
            desc="Multilingual website showcasing translator's services."
            tech="Bootstrap 4, jQuery, Animate.css."
            demo="https://adaptino.netlify.com/"
          />
          {/* Project 2 */}
          <FlipCard
            frontImage={<PogChamp />}
            title="PogChamp"
            desc="Overwatch fan app displaying info about all characters. I also added custom flavor texts."
            tech="Create React App, Hooks, Media Queries, Flexbox, Grid"
            demo="https://pogchamp.netlify.com/"
            code="https://github.com/Wolfenek/PogChamp"
          />
          {/* Project 3 */}
          <FlipCard
            frontImage={<Guess />}
            title="Guess the Sound"
            desc="Interactive sound game. Listen to tracks and choose the right answer."
            tech="Create React App, Hooks, Flexbox"
            demo="https://guess-the-sound.netlify.com/"
            code="https://github.com/Wolfenek/household_sounds"
          />
          {/* Project 4 */}
          <FlipCard
            frontImage={<Tauren />}
            title="MooMooSmile"
            desc="Tauren dating app landing page. Includes random string generator and humorous WoW references."
            tech="Bootstrap 4, JavaScript, jQuery"
            demo="https://wolfenek.github.io/Tauren-Dating-App-Page/"
            code="https://github.com/Wolfenek/Tauren-Dating-App-Page"
          />
          {/* Project 5 */}
          <FlipCard
            frontImage={<OnlineResume />}
            title="Responsive Online Resume"
            desc="Document displaying info about work experience, skills, hobbies, and other. A generic version is available on GitHub"
            tech="SCSS, Flexbox, Grid"
            demo="https://wolfenek.github.io/Responsive-Resume-Template/"
            code="https://github.com/Wolfenek/Responsive-Resume-Template"
          />
        </div>
      </div>
    </section>
  </Layout>
);

export default IndexPage;
